export const bannerWrapper =
  'tw:flex tw:items-center tw:justify-center tw:gap-micro tw:h-10 tw:w-full tw:bg-warn/10 tw:pl-base tw:pr-micro';

export const bannerIcon = 'tw:text-warn tw:text-16 tw:shrink-0';

export const bannerMessage = 'tw:flex-1 tw:text-warn tw:text-14 tw:leading-[18px] tw:font-regular';

export const bannerButton = 'tw:text-14 tw:leading-4 tw:font-regular tw:rounded-4';
